import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react'
import { useDispatch } from 'react-redux'
import { setPhaseExpanded } from 'redux/slices/activeWorkout'

export default function PhaseHeader({ 
    profileType,
    groupId,
    athleteId,
    phaseIndex,
    phase 
}) {

    const dispatch = useDispatch()

    const TogglePhaseExpanded = () => {

        var value = !phase.expanded

        const payload = {
            profileType: profileType,
            groupId: groupId,
            athleteId: athleteId,
            phaseIndex: phaseIndex,
            value: value
        }

        dispatch(setPhaseExpanded(payload))

    }

    // console.log(phase)

    return (
        <div 
            className="p-4 gap-x-6 flex items-center border-b border-gray-200 cursor-pointer"
            onClick={TogglePhaseExpanded}
        >
            <h2 className='text-2xl font-normal flex-grow select-none'>
                {phase.name}
            </h2>

            <p className='text-gray-600 select-none'>
                {phase.exercises.length} exercise{phase.exercises.length > 1 ? 's' : ''}
            </p>

            {phase.type === 'circuit' && (
                <p className='text-gray-600 select-none'>
                    {phase.circuitRounds} round{phase.circuitRounds > 1 ? 's' : ''}
                </p>
            )}

            {phase.expanded && <ChevronsDownUp className="h-6 w-6 text-gray-500" />}

            {!phase.expanded && <ChevronsUpDown className="h-6 w-6 text-gray-500" />}
        </div>
    )
}